import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AppState } from '../../../core/store/app.state';
import { select, Store } from '@ngrx/store';
import {
  loadDirectorById,
  resetSelectedDirector,
} from '../../../core/store/director/director.actions';
import { Observable } from 'rxjs';
import { CompanyDirectorship, Director } from '../../../core/models';
import { getSelectedDirector } from '../../../core/store/director/director.selectors';

@Component({
  selector: 'app-directorship-profile-modal',
  templateUrl: './directorship-profile-modal.component.html',
  styleUrls: ['./directorship-profile-modal.component.scss'],
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: {
    '[style.display]': '"flex"',
    '[style.flex-direction]': '"column"',
    '[style.overflow]': '"auto"',
  },
})
export class DirectorshipProfileModalComponent implements OnInit, OnDestroy {
  @Input() directorship: CompanyDirectorship;
  director$: Observable<Director | null> = this.store.pipe(
    select(getSelectedDirector)
  );
  constructor(
    public activeModal: NgbActiveModal,
    private store: Store<AppState>
  ) {}

  ngOnInit(): void {
    this.store.dispatch(
      loadDirectorById({ id: this.directorship.director.id })
    );
  }

  closeModal() {
    this.activeModal.dismiss('Cross click');
  }

  ngOnDestroy(): void {
    this.store.dispatch(resetSelectedDirector());
  }
}
